var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4711 35.0548C34.7534 35.0548 38.2249 31.5833 38.2249 27.301C38.2249 23.0187 34.7534 19.5472 30.4711 19.5472C26.1888 19.5472 22.7173 23.0187 22.7173 27.301C22.7173 31.5833 26.1888 35.0548 30.4711 35.0548Z",
    fill: "#F6F5FF",
    stroke: "#525254",
    strokeWidth: 0.945454,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4712 41.0189C20.6627 39.1869 22.293 37.6815 24.2139 36.6393C26.1349 35.5972 28.2857 35.0513 30.4712 35.0513C32.6566 35.0513 34.8075 35.5972 36.7284 36.6393C38.6494 37.6815 40.2797 39.1869 41.4712 41.0189",
    stroke: "#525254",
    strokeWidth: 0.945454,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson1);
export default __webpack_public_path__ + "static/media/person1.ab0950f96e34bc3dc380e713e73f327f.svg";
export { ForwardRef as ReactComponent };